import { defineComponent as t, inject as p, onBeforeUnmount as s, openBlock as l, createElementBlock as m, normalizeStyle as f, unref as r, normalizeClass as c } from "vue";
import { POPPER_CONTENT_INJECTION_KEY as i } from "./index558.js";
import { useNamespace as _ } from "./index559.js";
var y = /* @__PURE__ */ t({
  name: "ElPopperArrow",
  inheritAttrs: !1,
  __name: "arrow",
  setup(u, { expose: o }) {
    const a = _("popper"), { arrowRef: e, arrowStyle: n } = p(
      i,
      void 0
    );
    return s(() => {
      e.value = void 0;
    }), o({
      /**
       * @description Arrow element
       */
      arrowRef: e
    }), (w, E) => (l(), m(
      "span",
      {
        ref_key: "arrowRef",
        ref: e,
        class: c(r(a).e("arrow")),
        style: f(r(n)),
        "data-popper-arrow": ""
      },
      null,
      6
      /* CLASS, STYLE */
    ));
  }
});
export {
  y as default
};
